"use client";

import React, { useCallback } from "react";
import { ChevronDown } from "lucide-react";

import { FONT_OPTIONS } from "@/lib/themes/fonts";

interface FontSelectorProps {
  value: string;
  onChange: (font: string) => void;
}

export const FontSelector = React.memo(function FontSelector({
  value,
  onChange,
}: FontSelectorProps): React.ReactElement {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  const currentFont = FONT_OPTIONS.find((f) => f.key === value);

  return (
    <div className="relative w-full max-w-xs">
      <select
        value={value}
        onChange={handleChange}
        className="w-full appearance-none rounded-lg border border-border bg-card px-4 py-3 pr-10 text-sm font-medium text-foreground transition-colors hover:border-primary/40 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
      >
        {FONT_OPTIONS.map((font) => (
          <option key={font.key} value={font.key}>
            {font.label} — {font.description}
          </option>
        ))}
      </select>
      <ChevronDown
        size={16}
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground"
      />
      {currentFont && currentFont.key !== "default" && (
        <p
          className="mt-3 text-base text-muted-foreground"
          style={{ fontFamily: currentFont.cssFamily }}
        >
          The quick brown fox jumps over the lazy dog
        </p>
      )}
    </div>
  );
});
